export default __webpack_public_path__ + "static/latha-92d56f4ded223ceaa1d9775ef621047c.png";